import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ConnectedProps } from "react-redux";
import { Skeleton } from "antd";

import { StatisticsCardProps } from "../../../../../utils";
import educatorStatisticsCard from "../../../../../utils/constants/statisticsCard";
import StatisticsSingle from "./StatisticsSingle";
import connector from "./Container";

const UserStatistics = (props: ConnectedProps<typeof connector>) => {
  const {
    statistics,
    loading,
    loaded,
    actions: { getLearnerStatistics },
  } = props;

  const { id } = useParams();
  const [statisticsData, setStatisticsData] = useState<StatisticsCardProps[]>(
    []
  );

  useEffect(() => {
    getLearnerStatistics({ query: id });
  }, []);

  useEffect(() => {
    if (statistics) {
      let data: StatisticsCardProps[] = [];
      educatorStatisticsCard.slice(0, 3).forEach((item) => {
        data.push({ ...item, progress: "" });
      });

      data[0].progress = `${statistics.completedCourses}/${statistics.totalCourses}`;
      data[1].progress = `${statistics.completedLessons}/${statistics.totalLessons}`;
      data[2].progress = `${statistics.completedQuizzes}/${statistics.totalQuizzes}`;
      setStatisticsData(data);
    }
  }, [statistics]);

  if (loading) {
    return (
      <div className="h-[190px]">
        <Skeleton active paragraph={{ rows: 5 }} />
      </div>
    );
  }

  return (
    <>
      <div className="text-neutral-600 font-semibold text-base">Statistics</div>
      <div className="mt-4 gap-3 w-full flex justify-between">
        {statisticsData.map((statistics, index) => (
          <StatisticsSingle key={index} statistics={statistics} />
        ))}
      </div>
    </>
  );
};

export default UserStatistics;
